import { Registration } from "./registration";
import {ServiceAttribute} from "./service-attribute";
import {ServiceCategory} from "./service-category";
import {ServiceProperties} from "./service-properties";
import {TutorialBase} from "./tutorial-base";
import { ServiceGroup } from "./service-group";

export class Service extends TutorialBase {
  public id: string;
  public name: string;
  public description: string;
  public version: string;
  public active: boolean;
  public highlight: boolean = false;
  public archived: boolean;
  public logoFileId: string;
  public serviceAttributes: ServiceAttribute[] = [];
  public serviceCategories: ServiceCategory[] = [];
  public sortOrder: number;
  public serviceJsonProperties: ServiceProperties = new ServiceProperties();
  public numberOfPublishes: number;
  public lastPublishDate: Date;
  public lastPublisher: string;
  public lastPublishedBy: string;
  public registrations: Registration[];
  public statusesInExternalServers: any[];
  public publishHistory: any[];
  public showExternalinList: boolean = false;
  public lastPublish: any;
  public isMyAccountPage: boolean = false;
  public serviceGroup: ServiceGroup = null;
  public businessKey: string;
}
